import { default as _91_46_46_46404_93HIGKBaJU4mMeta } from "/builds/hatmeo/shoe-nuxt/pages/[...404].vue?macro=true";
import { default as _91slug_93OFeSLnBuhdMeta } from "/builds/hatmeo/shoe-nuxt/pages/article/[slug].vue?macro=true";
import { default as _91slug_930NzSSHY7wYMeta } from "/builds/hatmeo/shoe-nuxt/pages/blog/[slug].vue?macro=true";
import { default as cart7c8mdjIg2AMeta } from "/builds/hatmeo/shoe-nuxt/pages/cart.vue?macro=true";
import { default as checkoutFINWtQBrfWMeta } from "/builds/hatmeo/shoe-nuxt/pages/checkout.vue?macro=true";
import { default as _91id_932mqBQMMVAeMeta } from "/builds/hatmeo/shoe-nuxt/pages/collections/[id].vue?macro=true";
import { default as index6B22mK6SGmMeta } from "/builds/hatmeo/shoe-nuxt/pages/index.vue?macro=true";
import { default as _91page_93akvFRcOm0fMeta } from "/builds/hatmeo/shoe-nuxt/pages/pages/[page].vue?macro=true";
import { default as _91sku_93GQHIftTVFKMeta } from "/builds/hatmeo/shoe-nuxt/pages/products/[sku].vue?macro=true";
import { default as _91order_id_93bGaSriEygnMeta } from "/builds/hatmeo/shoe-nuxt/pages/success/[order_id].vue?macro=true";
export default [
  {
    name: "404",
    path: "/:404(.*)*",
    component: () => import("/builds/hatmeo/shoe-nuxt/pages/[...404].vue")
  },
  {
    name: "article-slug",
    path: "/article/:slug()",
    component: () => import("/builds/hatmeo/shoe-nuxt/pages/article/[slug].vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/builds/hatmeo/shoe-nuxt/pages/blog/[slug].vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/builds/hatmeo/shoe-nuxt/pages/cart.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: checkoutFINWtQBrfWMeta || {},
    component: () => import("/builds/hatmeo/shoe-nuxt/pages/checkout.vue")
  },
  {
    name: "collections-id",
    path: "/collections/:id()",
    component: () => import("/builds/hatmeo/shoe-nuxt/pages/collections/[id].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/hatmeo/shoe-nuxt/pages/index.vue")
  },
  {
    name: "pages-page",
    path: "/pages/:page()",
    component: () => import("/builds/hatmeo/shoe-nuxt/pages/pages/[page].vue")
  },
  {
    name: "products-sku",
    path: "/products/:sku()",
    component: () => import("/builds/hatmeo/shoe-nuxt/pages/products/[sku].vue")
  },
  {
    name: "success-order_id",
    path: "/success/:order_id()",
    meta: _91order_id_93bGaSriEygnMeta || {},
    component: () => import("/builds/hatmeo/shoe-nuxt/pages/success/[order_id].vue")
  }
]